export const SAVE_ALL_FINANCIAL_RECURRENCES = 'SAVE_ALL_FINANCIAL_RECURRENCES'